import React from 'react'

const Trier = () => {
  return (
    <div>this is a trier for nested routing</div>
  )
}

export default Trier